import { HiOutlineExclamationTriangle } from 'react-icons/hi2';
import './ConfirmDeleteModal.css';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  deleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

function ConfirmDeleteModal({ isOpen, deleting, onConfirm, onCancel }: ConfirmDeleteModalProps) {
  if (!isOpen) return null;

  return (
    <div className="cdm-overlay" onMouseDown={() => !deleting && onCancel()}>
      <div className="cdm-modal" onMouseDown={(e) => e.stopPropagation()}>
        <div className="cdm-icon">
          <HiOutlineExclamationTriangle />
        </div>
        <h2>Delete this row?</h2>
        <p>This will permanently remove the row. This cannot be undone.</p>
        <div className="cdm-footer">
          <button type="button" className="cdm-btn-cancel" onClick={onCancel} disabled={deleting}>Cancel</button>
          <button type="button" className="cdm-btn-delete" onClick={onConfirm} disabled={deleting}>
            {deleting ? 'Deleting…' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmDeleteModal;
